import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import {
  Box,
  Card,
  CircularProgress,
  Grid,
  Pagination,
  Tooltip,
} from "@mui/material";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import {
  CustomTableContainer,
  CustomTableHead,
  TableHeaderFont,
} from "../../../styles/tableContent.style";
import { useDispatch, useSelector } from "react-redux";

import { DisplayText } from "../../bankDetails/components/bankAccountsContent";
import empty from "../../../assets/illo.png";
import { getAsns } from "../redux/asnModuleSlice";
import { Link } from "react-router-dom";
import moment from "moment";

const EmptyContainer = () => (
  <Grid
    container
    spacing={0}
    direction="column"
    alignItems="center"
    justifyContent="center"
  >
    <br />
    <img src={empty} alt="empty" />

    <DisplayText> There are no ASNs to display</DisplayText>

    <br />
    <br />
  </Grid>
);

function AsnModuleTableContent() {
  const [page, setPage] = React.useState(1);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const { asnsList, loading } = useSelector((state) => state.asnModule);
  const dispatch = useDispatch();
  const asns = () => {
    dispatch(
      getAsns({
        page: page,
        per_page: rowsPerPage,
        search_key: "",
      })
    );
  };

  React.useEffect(() => {
    asns();
    // eslint-disable-next-line
  }, [page, rowsPerPage]);

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - asnsList.length) : 0;

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(1);
  };
  return loading ? (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <CircularProgress />
    </Box>
  ) : (
    <CustomTableContainer component={Card}>
      <Table aria-label="simple table">
        <CustomTableHead>
          <TableRow>
            <TableCell>
              <TableHeaderFont>Company Name </TableHeaderFont>
            </TableCell>
            <TableCell align="left">
              <TableHeaderFont>ASN Number</TableHeaderFont>
            </TableCell>
            <TableCell align="left">
              <TableHeaderFont>ASN Date</TableHeaderFont>
            </TableCell>
            <TableCell align="left">
              <TableHeaderFont>PO Number</TableHeaderFont>
            </TableCell>
            <TableCell align="center">
              <TableHeaderFont>Action</TableHeaderFont>
            </TableCell>
          </TableRow>
        </CustomTableHead>
        {asnsList?.data?.length !== 0 ? (
          <TableBody>
            {asnsList?.data?.map((row) => (
              <TableRow
                key={row.id}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell>
                  {row.Company?.company_name
                    ? row.Company?.company_name
                    : "Not Applicable"}
                </TableCell>
                <TableCell>
                  {row.asn_number ? row.asn_number : "Not Applicable"}
                </TableCell>
                <TableCell>
                  {row.asn_date
                    ? moment(row.asn_date).format("DD MMM YY")
                    : "Not Applicable"}{" "}
                </TableCell>
                <TableCell>
                  {row.Order?.order_number
                    ? row.Order?.order_number
                    : "Not Applicable"}
                </TableCell>
                <TableCell style={{ textAlign: "center" }}>
                  <Tooltip title="View ASN">
                    <Link
                      style={{ textDecoration: "none" }}
                      // eslint-disable-next-line
                      to={"/app/user-asns-list-view/" + `${row.id}`}
                    >
                      <RemoveRedEyeIcon
                        style={{
                          fill: "royalblue",
                          height: "18px",
                          width: "18px",
                        }}
                      />
                    </Link>
                  </Tooltip>
                </TableCell>
              </TableRow>
            ))}
            {emptyRows > 0 && (
              <TableRow style={{ height: 0 * emptyRows }}></TableRow>
            )}
          </TableBody>
        ) : (
          <TableBody>
            <TableRow>
              <TableCell colSpan={6}>
                <CustomTableContainer>
                  <EmptyContainer />
                </CustomTableContainer>
              </TableCell>
            </TableRow>
          </TableBody>
        )}
      </Table>
      <Grid
        container
        className="d-flex flex-row align-items-center justify-content-between w-100 px-3 text-muted"
        sx={{ height: "8vh", borderTop: "1px solid lightgray" }}
      >
        <Grid className="d-flex align-items-center gap-2">
          <span>Rows per page: </span>
          <select
            value={rowsPerPage}
            onChange={(e) => {
              setRowsPerPage(e.target.value);
              setPage(1);
            }}
          >
            <option value={10}>10</option>
            <option value={20}>20</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
          </select>
        </Grid>
        <Pagination
          sx={{
            width: "max-content",
          }}
          color="primary"
          variant="text"
          onChange={(_, newValue) => setPage(newValue)}
          count={asnsList?.pagination?.total_page}
          page={page}
          shape="rounded"
          onRowsPerPageChange={handleChangeRowsPerPage}
          showFirstButton
          showLastButton
        />
      </Grid>
    </CustomTableContainer>
  );
}

export default AsnModuleTableContent;
